import packageJson from '../../package.json'

// App version from package.json.
export const APP_VERSION = packageJson.version

// Short git commit hash of the running build, injected at build time (see dex/commands/build.ts).
export const APP_COMMIT_HASH = import.meta.env?.VITE_APP_COMMIT_HASH || 'unknown'
